import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../shared/auth.service';

@Directive({
    selector: '[isProvider]',
    standalone: false
})
export class IsProviderDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {

  }

  public ngOnInit(): void {

    if (this.authService.isProvider()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
